<template>
    <div class="field-container cta-field field-textarea">
        <div class="form-group">
            <label class="field-label" :for="field_id">{{ form_label }}</label>
            <textarea class="form-control" :placeholder="form_placeholder" :disabled="disabled" :id="field_id" v-model="input" :class="{ 'is-invalid': v.$error, 'is-valid': !v.$error && !v.$invalid && input }" />
            <transition name="fade">
                <div class="invalid-feedback" key="required" v-if="is_required && !v.required">{{ $t('i18n.fieldIsRequired') }}</div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: "",
        },
        v: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        field_id: {
            type: String,
            required: true,
        },
    },
    computed: {
        form_label: function () {
            return this.field.label;
        },
        form_placeholder: function () {
            return this.field.value ? this.field.value : this.field.placeholder;
        },
        is_required: function () {
            return this.field.required;
        },
        input: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            },
        },
    }
};
</script>